<template>
  <div class="floating-whatsapp-container" v-if="showButton">
    <router-link to="/whatsapp" class="floating-whatsapp-button">
      <span class="whatsapp-icon">
        <svg width="28" height="28" viewBox="0 0 24 24" fill="currentColor">
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.56-.01-.188 0-.495.074-.754.372-.26.297-.99.967-.99 2.357 0 1.388 1.014 2.731 1.155 2.921.142.19 2.006 3.045 4.848 4.272.678.292 1.207.466 1.621.596.682.217 1.303.187 1.793.113.547-.081 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347zm-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.051 3.488z"/>
        </svg>
      </span>
      <span v-if="unreadCount > 0" class="unread-badge">{{ unreadCount }}</span>
    </router-link>
  </div>
</template>

<script>
import { DashboardService } from '@/services/dashboard'

export default {
  name: 'FloatingWhatsAppButton',
  data () {
    return {
      unreadCount: 0,
      unreadCountInterval: null,
      showButton: false
    }
  },
  mounted () {
    // Check if mobile view
    this.checkMobileView()
    window.addEventListener('resize', this.checkMobileView)

    // Load initial unread count
    this.fetchUnreadCount()

    // Poll for unread count every 30 seconds
    this.unreadCountInterval = setInterval(() => {
      this.fetchUnreadCount()
    }, 30000)
  },
  beforeUnmount () {
    window.removeEventListener('resize', this.checkMobileView)

    // Clear polling interval
    if (this.unreadCountInterval) {
      clearInterval(this.unreadCountInterval)
    }
  },
  methods: {
    checkMobileView () {
      // Show button on mobile OR on desktop if there are unread messages
      const isMobile = window.innerWidth <= 768
      const hasUnread = this.unreadCount > 0
      this.showButton = isMobile || hasUnread
    },
    async fetchUnreadCount () {
      try {
        const result = await DashboardService.getWhatsAppUnreadCount()
        if (result.success) {
          this.unreadCount = result.unreadConversations || 0
          // Update button visibility when unread count changes
          this.checkMobileView()
        }
      } catch (error) {
        console.error('Error fetching WhatsApp unread count:', error)
      }
    }
  }
}
</script>

<style scoped>
.floating-whatsapp-container {
  position: fixed;
  bottom: 24px;
  right: 24px;
  z-index: 1000;
}

.floating-whatsapp-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;
  background: linear-gradient(135deg, #25d366 0%, #128c7e 100%);
  border-radius: 50%;
  box-shadow: 0 4px 16px rgba(37, 211, 102, 0.4);
  color: white;
  text-decoration: none;
  position: relative;
  transition: all 0.3s ease;
  animation: pulse-glow 2s infinite;
}

.floating-whatsapp-button:hover {
  transform: scale(1.1);
  box-shadow: 0 6px 24px rgba(37, 211, 102, 0.6);
}

.floating-whatsapp-button:active {
  transform: scale(0.95);
}

.whatsapp-icon {
  display: flex;
  align-items: center;
  justify-content: center;
}

.unread-badge {
  position: absolute;
  top: -4px;
  right: -4px;
  background: #ef4444;
  color: white;
  border-radius: 50%;
  min-width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 700;
  border: 3px solid white;
  box-shadow: 0 2px 8px rgba(239, 68, 68, 0.4);
  animation: badge-pulse 2s infinite;
}

@keyframes pulse-glow {
  0%, 100% {
    box-shadow: 0 4px 16px rgba(37, 211, 102, 0.4);
  }
  50% {
    box-shadow: 0 4px 24px rgba(37, 211, 102, 0.6);
  }
}

@keyframes badge-pulse {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
}

/* Adjust position for very small screens */
@media (max-width: 480px) {
  .floating-whatsapp-container {
    bottom: 80px;
    right: 20px;
  }

  .floating-whatsapp-button {
    width: 56px;
    height: 56px;
  }

  .whatsapp-icon svg {
    width: 26px;
    height: 26px;
  }
}
</style>
